import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { Answer } from 'modules/surveys/components/Analytics/ScoreResults/hooks'
import { useAnalytics } from 'modules/surveys/pages/Show/hooks'
import type { Question } from 'modules/surveys/store/models/AnalyticResult'

interface Props {
  answers: Answer[]
  question: Question
  isTable?: boolean
}

const Head = ({ answers, question, isTable = false }: Props) => {
  const { form, questionGroups, cycle } = useAnalytics()

  const questionGroupsCount =
    form.hasSchedule && cycle
      ? questionGroups.getQuestionGroupsInCycle(cycle).length
      : questionGroups.length

  const filtered = answers.filter((val) => {
    return val.value != null
  })

  return (
    <Box paddingX="s24" paddingY="s8" component={isTable ? 'thead' : 'div'}>
      <Text size="300" weight="semibold" color="grey800" whiteSpace="breakSpaces">
        {question.label}
      </Text>
      <Text size="200" color="grey600">
        {i18n.t('surveys.analytics.score.answers_count', {
          count: filtered.length,
          total: questionGroupsCount,
        })}
      </Text>
    </Box>
  )
}

export default observer(Head)
